import React from 'react';
import Navbar from '../components/landing/Navbar';
import Hero from '../components/landing/Hero';
import ScopeMarquee from '../components/landing/ScopeMarquee';
import BeforeAfter from '../components/landing/BeforeAfter';
import Steps from '../components/landing/Steps';
import Features from '../components/landing/Features';
import Conformity from '../components/landing/Conformity';
import Origin from '../components/landing/Origin';
import Pricing from '../components/landing/Pricing';
import FAQ from '../components/landing/FAQ';
import CTAFinal from '../components/landing/CTAFinal';
import Footer from '../components/landing/Footer';

const LandingPage = () => (
  <div className="min-h-screen w-full max-w-full overflow-x-hidden bg-paper selection:bg-navy selection:text-white">
    <Navbar />
    <main className="w-full max-w-full overflow-x-hidden">
      <Hero />
      <ScopeMarquee />
      <BeforeAfter />
      <Steps />
      <Features />
      <Conformity />
      <Origin />
      <Pricing />
      <FAQ />
      <CTAFinal />
    </main>
    <Footer />
  </div>
);

export default LandingPage;
